module.exports = __webpack_public_path__ + "static/img/tab-service-s3.f1463c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/tab-service-s3.png
// module id = zd7B
// module chunks = 0